var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 67,
    viewBox: "0 0 248 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.727 45.7382V46.2382H188.227H193.497H193.997V45.7382V34.7906L202.326 20.6621L202.77 19.9082H201.895H195.877H195.586L195.442 20.1618L190.858 28.2544L186.247 20.1607L186.104 19.9082H185.813H179.795H178.919L179.364 20.6624L187.727 34.8248V45.7382Z",
    fill: "url(#paint0_linear_267_99226)",
    stroke: "url(#paint1_linear_267_99226)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.43 45.7382V46.2382H150.93H159.192C162.001 46.2382 164.466 45.6807 166.569 44.5463C168.664 43.4165 170.297 41.8568 171.456 39.8701L171.457 39.8679C172.616 37.8578 173.19 35.5828 173.19 33.0562C173.19 30.5297 172.616 28.265 171.456 26.2763C170.297 24.2896 168.664 22.7299 166.569 21.6001C164.466 20.4658 162.001 19.9082 159.192 19.9082H150.93H150.43V20.4082V45.7382ZM165.963 37.0974L165.961 37.1002C165.349 38.2181 164.488 39.0909 163.368 39.7253C162.255 40.3337 160.914 40.6482 159.328 40.6482H156.7V25.4982H159.328C160.916 25.4982 162.258 25.8134 163.372 26.4228C164.489 27.0343 165.35 27.8947 165.961 29.0122L165.961 29.0122L165.965 29.0185C166.594 30.1311 166.92 31.4707 166.92 33.0562C166.92 34.6174 166.595 35.9591 165.963 37.0974Z",
    fill: "url(#paint2_linear_267_99226)",
    stroke: "url(#paint3_linear_267_99226)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.19 42.7596L117.19 42.7596L117.196 42.7662C118.468 43.9909 119.951 44.9434 121.64 45.6238C123.336 46.3069 125.168 46.646 127.131 46.646C129.094 46.646 130.926 46.3069 132.622 45.6238C134.312 44.943 135.785 43.9897 137.035 42.7629L137.035 42.7628C138.306 41.5155 139.295 40.0671 140.001 38.421C140.709 36.7674 141.061 34.9771 141.061 33.056C141.061 31.136 140.71 29.3466 140.002 27.6938C139.319 26.0462 138.34 24.6073 137.068 23.3814C135.818 22.1555 134.345 21.2026 132.656 20.5222C130.959 19.8388 129.116 19.5 127.131 19.5C125.147 19.5 123.303 19.8388 121.606 20.5222C119.917 21.2026 118.434 22.1551 117.162 23.3798L117.162 23.3798L117.159 23.3831C115.91 24.6086 114.933 26.046 114.228 27.691L114.228 27.691L114.225 27.6966C113.541 29.3488 113.201 31.1371 113.201 33.056C113.201 34.9771 113.553 36.7674 114.262 38.421C114.966 40.0651 115.943 41.5125 117.19 42.7596ZM130.138 40.3112L130.138 40.3112L130.134 40.3128C129.226 40.6929 128.227 40.886 127.131 40.886C126.036 40.886 125.025 40.6931 124.092 40.3119C123.176 39.9283 122.369 39.3972 121.668 38.7178C120.971 38.0201 120.431 37.1947 120.047 36.2363C119.666 35.2817 119.471 34.2236 119.471 33.056C119.471 31.8882 119.666 30.8429 120.046 29.9133L120.046 29.9133L120.047 29.9097C120.431 28.9501 120.972 28.1238 121.671 27.4256C122.371 26.7254 123.175 26.1969 124.085 25.837L124.085 25.837L124.09 25.8348C125.023 25.4531 126.035 25.26 127.131 25.26C128.227 25.26 129.226 25.4531 130.134 25.8332L130.134 25.8334L130.147 25.8384C131.08 26.1989 131.893 26.7274 132.592 27.4256C133.29 28.1238 133.831 28.9501 134.215 29.9097L134.215 29.9097L134.216 29.9133C134.597 30.8429 134.791 31.8882 134.791 33.056C134.791 34.2236 134.597 35.2817 134.215 36.2363C133.832 37.1947 133.291 38.02 132.594 38.7177C131.894 39.3958 131.077 39.9271 130.138 40.3112Z",
    fill: "url(#paint4_linear_267_99226)",
    stroke: "url(#paint5_linear_267_99226)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7111 42.7596L80.711 42.7596L80.7178 42.7662C81.9897 43.9909 83.4725 44.9434 85.1619 45.6238C86.858 46.3069 88.6899 46.646 90.6527 46.646C92.6154 46.646 94.4474 46.3069 96.1435 45.6238C97.8336 44.943 99.3065 43.9897 100.557 42.7629L100.557 42.7628C101.828 41.5155 102.817 40.0671 103.522 38.421C104.231 36.7674 104.583 34.9771 104.583 33.056C104.583 31.136 104.231 29.3466 103.523 27.6938C102.84 26.0462 101.862 24.6073 100.589 23.3814C99.3391 22.1555 97.8668 21.2026 96.1775 20.5222C94.4807 19.8388 92.6372 19.5 90.6527 19.5C88.6681 19.5 86.8246 19.8388 85.1279 20.5222C83.4385 21.2026 81.9557 22.1551 80.6838 23.3798L80.6838 23.3798L80.6805 23.3831C79.4314 24.6086 78.4541 26.046 77.7491 27.691L77.749 27.691L77.7467 27.6966C77.0623 29.3488 76.7227 31.1371 76.7227 33.056C76.7227 34.9771 77.0744 36.7674 77.7831 38.421C78.4877 40.0651 79.4641 41.5125 80.7111 42.7596ZM93.6593 40.3112L93.6593 40.3112L93.6556 40.3128C92.7476 40.6929 91.7486 40.886 90.6527 40.886C89.5575 40.886 88.5462 40.6931 87.6137 40.3119C86.6978 39.9283 85.8909 39.3972 85.1895 38.7178C84.4926 38.0201 83.9522 37.1947 83.5689 36.2363C83.1871 35.2817 82.9927 34.2236 82.9927 33.056C82.9927 31.8882 83.1871 30.8429 83.5674 29.9133L83.5674 29.9133L83.5689 29.9097C83.9527 28.9501 84.4939 28.1238 85.1922 27.4256C85.8923 26.7254 86.696 26.1969 87.6065 25.837L87.6065 25.837L87.612 25.8348C88.545 25.4531 89.5568 25.26 90.6527 25.26C91.7486 25.26 92.7476 25.4531 93.6556 25.8332L93.6555 25.8334L93.6685 25.8384C94.6015 26.1989 95.4149 26.7274 96.1131 27.4256C96.8114 28.1238 97.3526 28.9501 97.7364 29.9097L97.7364 29.9097L97.7379 29.9133C98.1182 30.8429 98.3127 31.8882 98.3127 33.056C98.3127 34.2236 98.1182 35.2817 97.7364 36.2363C97.3531 37.1947 96.8128 38.02 96.1158 38.7177C95.4158 39.3958 94.5984 39.9271 93.6593 40.3112Z",
    fill: "url(#paint6_linear_267_99226)",
    stroke: "url(#paint7_linear_267_99226)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6055 45.7382V46.2382H46.1055H51.3755H51.8755V45.7382V31.8647L62.3636 46.0357L62.5135 46.2382H62.7655H66.8455H67.3455V45.7382V20.4082V19.9082H66.8455H61.5755H61.0755V20.4082V33.9736L50.5497 20.1059L50.3997 19.9082H50.1515H46.1055H45.6055V20.4082V45.7382Z",
    fill: "url(#paint8_linear_267_99226)",
    stroke: "url(#paint9_linear_267_99226)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_267_99226",
    x1: 172.656,
    y1: 29.111,
    x2: 190.782,
    y2: 52.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_267_99226",
    x1: 172.656,
    y1: 29.111,
    x2: 190.782,
    y2: 52.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_267_99226",
    x1: 143.901,
    y1: 29.111,
    x2: 162.091,
    y2: 51.8514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_267_99226",
    x1: 143.901,
    y1: 29.111,
    x2: 162.091,
    y2: 51.8514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_267_99226",
    x1: 105.025,
    y1: 28.9831,
    x2: 122.813,
    y2: 55.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_267_99226",
    x1: 105.025,
    y1: 28.9831,
    x2: 122.813,
    y2: 55.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_267_99226",
    x1: 68.5466,
    y1: 28.9831,
    x2: 86.3346,
    y2: 55.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_267_99226",
    x1: 68.5466,
    y1: 28.9831,
    x2: 86.3346,
    y2: 55.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_267_99226",
    x1: 39.4063,
    y1: 29.111,
    x2: 57.7686,
    y2: 50.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_267_99226",
    x1: 39.4063,
    y1: 29.111,
    x2: 57.7686,
    y2: 50.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoody);
export default __webpack_public_path__ + "static/media/noody.c802b03a162c78f508d6f275d9c4be71.svg";
export { ForwardRef as ReactComponent };